import React from 'react';
import { useNavigate } from 'react-router-dom';

// MUI
import { Box, Chip, Typography } from '@mui/material';

// Types;
import { Moment } from 'moment';
import { DCFile } from '@/@types/lib/dataController';

// Custom
import HoverRippleButtonBase from './HoverRippleButtonBase';

type IPublicIzletCardProps = {
  id: number;
  img: DCFile;
  gsImgUrl: string;
  odrediste: string;
  opis: string;
  organizator: string;
  prviDan: Moment;
};

const PublicIzletCard = (props: IPublicIzletCardProps) => {
  const { id, img, odrediste, opis, organizator, prviDan, gsImgUrl } = props;

  const navigate = useNavigate();

  const handleClick = (evt: React.MouseEvent<HTMLButtonElement>): void => {
    navigate(`/izleti/${id}`);
  };

  return (
    <HoverRippleButtonBase onClick={handleClick}>
      <Box width="100%" display="flex" flexDirection="column" rowGap={2}>
        <img style={{ aspectRatio: '4/3', width: '100%' }} src={img.content ? `data:image/jpeg;base64,${img.content}` : gsImgUrl} />
        <Box>
          <Typography variant="h5" fontWeight={700}>
            {odrediste}
          </Typography>
          <Typography variant="h6" color="black" fontSize="1.2rem" fontWeight={500}>
            {prviDan.format('dddd, D.M.YYYY.')}
          </Typography>
        </Box>
        <Box>
          <Typography fontSize="1.1rem">{opis && opis.length > 240 ? `${opis.substring(0, 240)}...` : opis}</Typography>
        </Box>
        <Box>
          <Chip size="small" label={organizator} color="success" />
        </Box>
      </Box>
    </HoverRippleButtonBase>
  );
};

export default PublicIzletCard;
